export const buildForcedReloadUrl = (route) => {
    const { origin, pathname } = window.location
    const normalizedRoute = route.startsWith('#') ? route : `#${route}`

    return `${origin}${pathname}?reload=${Date.now()}${normalizedRoute}`
}

export const forceReloadTo = (route) => {
    window.location.replace(buildForcedReloadUrl(route))
}
